import { Button, Col, Form, Input, message, Row, Switch } from 'antd'
import React, { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { showErrors } from '~/utils/helpers'
import { useCreateSoftwaresMutation, useEditSoftwaresMutation } from './mutation'

export const SoftwareForm: React.FC<{ onSuccess: () => void, item?: any }> = ({ onSuccess, item }) => {
  const queryClient = useQueryClient()
  const updateMutation = useEditSoftwaresMutation(item?.id)
  const createMutation = useCreateSoftwaresMutation()
  const mutation = item == null ? createMutation : updateMutation

  const editSoftware = useCallback(
    (values) => {
      mutation.mutate(
        values,
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['softwares'] })
            message.success('Success')
            onSuccess()
          },
          onError: showErrors
        }
      )
    },
    [mutation, queryClient, onSuccess]
  )

  return (
    <Form layout="vertical" onFinish={editSoftware} initialValues={{ is_latest: false, ...item }}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please enter name' }]}
          >
            <Input placeholder="Please enter name" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item name="is_latest" label="Is latest" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="appstream_app_name"
            label="Appstream App Name"
            rules={[{ required: true, message: 'Please enter appstream app name' }]}
          >
            <Input placeholder="Please enter appstream app name" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Button type="primary" htmlType="submit" loading={mutation.isPending} disabled={mutation.isPending}>
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
